<template>
  <section>
    <b-loading :active="loading" />
    <w-modal :value="value" width="1536" content-padding="px-6" @close="close">
      <template #header>
        <h1 class="font-medium text-xl">
          例行性訂購排程設定
        </h1>
      </template>
      <template #content>
        <template v-if="!loading">
          <schedule-setting
            ref="scheduleSetting"
            :groupBuyingSetting="groupBuyingSetting"
            :groupBuyings="groupBuyings"
            :scheduleSetting="scheduleSetting"
            :viewMode="viewMode"
            inDialog
            @valid="valid = $event"
          />
        </template>
      </template>
      <template #footer>
        <w-button
          class="mr-8"
          type="text"
          @click="close"
        >
          取消
        </w-button>
        <w-button
          v-if="!viewMode"
          :disabled="loading || !valid"
          @click="onSubmit"
        >
          儲存
        </w-button>
      </template>
    </w-modal>
  </section>
</template>

<script>
import ScheduleEditModal from './ScheduleEditModal';

export default ScheduleEditModal;
</script>

<style lang="scss" scoped>
@import './ScheduleEditModal';
</style>
